import React, { Component } from "react"
import intl from "react-intl-universal"
import "../pay/pay.css"
import { Table } from "antd"
import { getOrderById } from "../../../api/console/order/Order"
import { getPageQuery } from "../../../common/util/util"


class Detail extends Component {

    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            orderDetail: {},
            initDone: false,
            orderId: getPageQuery().orderId,
        }
        this.getOrderDetail = this.getOrderDetail.bind(this)
    }

    componentWillMount () {
        this.getOrderDetail()
    }

    getOrderDetail () {
        let orderId = getPageQuery().orderId
        getOrderById(orderId).then((res) => {
            if (res.code === 0) {
                this.setState({
                    orderDetail: res.data.order,
                    initDone: true,
                })
            }
        }, (error) => {
            console.log("get response failed!")
        }
        )
    }


    render () {
        const { initDone, orderDetail } = this.state
        const data = [
            orderDetail,
        ]

        // 订单号
        // 商品名称
        // 服务时长
        // 数量
        // 订单创建时间
        // 优惠金额
        // 应付金额
        const columns = [
            {
                title: intl.get('order.detail_col1'),
                dataIndex: 'orderNumber',
                key: 'orderNumber',
                // render: text => <a>{text}</a>,
            },
            {
                title: intl.get('order.detail_col2'),
                dataIndex: 'comboName',
                key: 'comboName',
            },
            {
                title: intl.get('order.detail_col3'),
                dataIndex: 'statusCw',
                key: 'statusCw',
            },
            {
                title: intl.get('order.detail_col4'),
                dataIndex: 'start',
                key: 'start',
            },
            {
                title: intl.get('order.detail_col5'),
                dataIndex: 'end',
                key: 'end',
            },
            {
                title: intl.get('order.detail_col6'),
                dataIndex: 'usageCount',
                key: 'usageCount',
            },
            {
                title: intl.get('order.detail_col7'),
                dataIndex: 'leftCount',
                key: 'leftCount',
            },
        ]

        return (
            initDone &&
            <div>
                <div className="welcome">
                    <div style={{ width: '100%', display: 'flex', justifyContent: "space-between", padding: '0 20px' }}>
                        <div className="font-20-l28">
                            {intl.get('order.detail_title')}
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div style={{ padding: '16px 12px' }}>
                        <div className="row" style={{ marginLeft: '0px', marginRight: '0px' }}>
                            <div className="col-12" style={{ padding: '0 8px' }}>
                                <div className="bg-white">
                                    <div className="px-4 p-3">
                                        <Table columns={columns} dataSource={data} pagination={false} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Detail
